import {useRouter} from 'next/router';
import {SortUrlService} from 'plugins/modules/sorting/services/SortUrlService';
import {useMemo} from 'react';

export const useSortUrlService = (
    query: SortUrlService['query'],
    onSortParamChange: SortUrlService['onParamsChange']
) => {
    const router = useRouter();

    return useMemo<SortUrlService>(
        () =>
            new SortUrlService(query, onSortParamChange, {
                query: router.query,
            }),
        [onSortParamChange, query, router.query]
    );
};
